import { defineMessages } from 'react-intl';

import { DiscordAccount } from '#src/components/settings/DiscordAccount/index.tsx';
import { SettingsSection } from '#src/components/settings/SettingsSection/index.tsx';
import { TwitterAccount } from '#src/components/settings/TwitterAccount/index.tsx';

const messages = defineMessages({
  title: {
    defaultMessage: 'Socials',
  },
});

export const SocialAccounts = () => {
  return (
    <SettingsSection {...messages}>
      <TwitterAccount />
      <DiscordAccount />
    </SettingsSection>
  );
};
